// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1m8AJ","choiceBoxes":"toolbarselects_choiceBoxes__1nYL6","simpleField":"toolbarselects_simpleField__39EEN"};